<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Canonical Theology</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for">Foreword, by Craig G. Bartholomew</a></p>
<p class="Toc2" id="ack"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="Toc" id="ch001"><a href="#/xhtml/chapter001#ch001"><span class="space"> </span>1.<span class="space"> </span>Canon vs. Community?</a></p>
<p class="Toc" id="ch002"><a href="#/xhtml/chapter002#ch002"><span class="space"> </span>2.<span class="space"> </span>Defining the Intrinsic Canon</a></p>
<p class="Toc" id="ch003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample"><span class="space"> </span>3.<span class="space"> </span>Intrinsic Canonicity and the Inadequacy of the Community Approach</span></p>
<p class="Toc" id="ch004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample"><span class="space"> </span>4.<span class="space"> </span>Communitarian Approaches to Theology</span></p>
<p class="Toc" id="ch005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample"><span class="space"> </span>5.<span class="space"> </span>The Rule of Faith</span></p>
<p class="Toc" id="ch006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample"><span class="space"> </span>6.<span class="space"> </span>Sola Scriptura: reductio ad absurdum?</span></p>
<p class="Toc" id="ch007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample"><span class="space"> </span>7.<span class="space"> </span>Sola Scriptura and the Theology of the Trinity: A Case Study</span></p>
<p class="Toc" id="ch008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample"><span class="space"> </span>8.<span class="space"> </span>The Canonical Approach to Systematic Theology: Revisiting the Analogy of Scripture</span></p>
<p class="Toc" id="ch009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample"><span class="space"> </span>9.<span class="space"> </span>Canonical Hermeneutics and Theopathic Language</span></p>
<p class="Toc1" id="ch010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">10.<span class="space"> </span>What Might a Canonical Theology Look Like? The Nature of Divine Love</span></p>
<p class="Toc2a" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc2a" id="ind001"><span href="#/xhtml/index001#ind001" title="Link target outside of Sample">Modern Author Index</span></p>
<p class="Toc2a" id="ind002"><span href="#/xhtml/index002#ind002" title="Link target outside of Sample">Subject Index</span></p>
<p class="Toc2a" id="ind003"><span href="#/xhtml/index003#ind003" title="Link target outside of Sample">Scripture Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?28999348